import type { CSSProperties } from "react"

type ThinknadoLoaderProps = {
  size?: number
  className?: string
  label?: string
}

const paths = [
  ["M60 145 C54 132 70 124 56 112 C42 100 66 92 52 80 C38 66 58 54 46 38", "#00E5E5", "10", "0s"],
  ["M60 145 C68 130 48 122 66 108 C84 94 56 84 76 68 C96 50 70 36 84 18", "#FF2AA3", "10", "-.12s"],
  ["M60 145 C48 128 76 116 58 100 C40 84 86 74 60 54 C44 40 76 28 66 12", "#FFE600", "9", "-.24s"],
  ["M60 145 C70 132 52 118 66 104 C82 88 46 80 64 60 C82 42 50 34 58 16", "#FFE600", "6", "-.36s"],

  ["M58 145 C44 128 78 120 50 104 C28 90 74 82 42 62 C24 46 62 36 38 22", "#00E5E5", "7", "-.48s"],
  ["M62 145 C82 130 40 118 74 100 C102 84 50 76 88 56 C106 44 84 28 98 18", "#00E5E5", "7", "-.6s"],
  ["M59 145 C50 134 80 120 62 108 C46 96 92 82 66 66 C44 52 92 36 74 20", "#FF2AA3", "7", "-.72s"],
  ["M61 145 C72 132 44 116 62 102 C82 86 38 72 58 56 C76 40 42 30 52 14", "#FFE600", "4", "-.84s"],

  ["M54 132 C38 112 88 102 44 84 C20 72 78 58 34 38", "#FFE600", "5", "-.96s"],
  ["M66 132 C86 110 34 98 78 80 C106 66 48 54 92 34", "#FF2AA3", "5", "-1.08s"],
  ["M58 126 C42 106 92 96 58 76 C30 60 86 48 54 28", "#00E5E5", "5", "-1.2s"],
  ["M64 126 C78 108 44 94 68 76 C92 58 44 48 64 26", "#FF2AA3", "3", "-1.32s"],
] as const

export function ThinknadoLoader({
  size = 96,
  className = "",
  label = "Loading",
}: ThinknadoLoaderProps) {
  return (
    <svg
      viewBox="0 0 120 160"
      className={className}
      role="img"
      aria-label={label}
    >
      {/* <defs>
        <filter id="thinknado-blur">
          <feGaussianBlur stdDeviation="1.4" />
        </filter>
      </defs> */}

      <g className="thinknado">
        {paths.map(([d, color, width, delay], i) => (
          <path
            key={i}
            d={d}
            stroke={color}
            strokeWidth={width}
            className="thinknado-path"
            style={{ "--delay": delay } as CSSProperties}
          />
        ))}
      </g>

      <style>{`
        .thinknado {
          transform-origin: center center;
          animation: thinknado-breathe 1.6s ease-in-out infinite;
        }

        .thinknado-path {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          filter: url(#thinknado-blur);
          stroke-dasharray: 36 88;
          animation: thinknado-rise 1.35s linear infinite;
          animation-delay: var(--delay);
        }

        @keyframes thinknado-rise {
          from { stroke-dashoffset: 124; }
          to { stroke-dashoffset: 0; }
        }

        @keyframes thinknado-breathe {
          0%, 100% { transform: scale(.96) translateY(2px); }
          50% { transform: scale(1.03) translateY(-2px); }
        }

        @media (prefers-reduced-motion: reduce) {
          .thinknado,
          .thinknado-path {
            animation: none;
          }
        }
      `}</style>
    </svg>
  )
}